<template>
    <div class="main">
        <!-- <van-swipe v-if="SwiperImgs" class="swipe" :autoplay="3000">
            <van-swipe-item v-for="(img,index) in SwiperImgs" :key="index">
                <video v-if="img.mime == 'mp4'" controls preload="auto" :poster="img.cover">
                    <source :src="img.url" type="video/mp4">
                    您的浏览器不支持 HTML5 视频,请更换浏览器。比如 Chrome 、 Firefox 等主流浏览器。
                </video>
                <img v-else v-lazy="img.url" @click="previewSwiper(SwiperImgs,index)">                
            </van-swipe-item>
        </van-swipe> -->
        <the-venue :info="clubInfo"></the-venue>
        <!-- <div v-if="courseList[0]" class="model-box course-mod mtm bcw">
            <div class="model-box__hd clear">
                <h3 class="left">精品团课</h3>
                <router-link :to="{name: 'courselist',params:{ clubId:clubInfo.id }}" title="精品团课" class="right fs2 c9"><van-icon name="arrow" class="vam"/></router-link>
            </div>
            <div class="model-box__bd clear">
                <van-swipe :loop="false" :width="235">
                    <van-swipe-item v-for="item in courseList" :key="item.id" >
                        <course-card :course="item" style="width:220px"></course-card>
                    </van-swipe-item>
                </van-swipe>
                <course-card v-for="item in courseList" :key="item.id" :course="item"></course-card>              
            </div>
        </div> -->
        <!-- <div v-if="cardList[0]" class="model-box mtm bcw">
            <div class="model-box__hd clear">
                <h3 class="left">练球卡/包月课</h3>
                <router-link :to="{name: 'cyclelist',params:{ clubId:clubInfo.id }}" title="周期卡" class="right fs2 c9"><van-icon name="arrow" class="vam"/></router-link>
            </div>
            <div class="model-box__bd clear">
                <cycle-card v-for="item in cardList" :key="item.id" :course="item"></cycle-card>
            </div>
        </div> -->
        <div v-if="clubInfo.desc" class="model-box mtm bcw">
            <div class="model-box__hd clear green mbm">
                <h3 class="left fs3">场馆介绍</h3>
                <router-link :to="{name: 'venueinfo',params: {clubid: clubInfo.id}}" title="场馆介绍" class="right fs2 green"><van-icon name="arrow" class="vam"/></router-link>
            </div>
            <div class="model-box__bd clear">
                <!-- <div class="fs2" v-html="clubInfo.desc" style="height:1.5rem;overflow:hidden"></div> -->
                <div class="fs2">{{newMessage3}}</div>
            </div>
        </div>
        <div v-if="coachList[0]" class="model-box mtm bcw">
            <div class="model-box__hd clear green mbm">
                <h3 class="left fs3">专业教练</h3>
                <router-link :to="{name: 'coachlist',params:{ clubId:clubInfo.id }}" title="私人教练列表" class="right fs2 green"><van-icon name="arrow" class="vam"/></router-link>
            </div>
            <div class="model-box__bd clear">
                <van-row gutter="10">
                    <van-col v-for="(item,index) in coachList" :key="index" v-if="index<3" span="8">
                        <avatar-card :coachInfo="item"></avatar-card>
                    </van-col>
                </van-row>
            </div>
        </div>
        <!-- <the-copyright></the-copyright> -->
        <the-tabbar></the-tabbar>
    </div>
</template>
<script>
import Vue from 'vue';
import { Row, Col ,Lazyload,Swipe,Icon, SwipeItem, Card,ImagePreview } from 'vant';
import TheTabbar from '@/components/TheTabbar';
import TheCopyright from '@/components/TheCopyright';
import TheVenue from '@/components/TheVenue';
import CycleCard from '@/components/CycleCard';
import CourseCard from '@/components/CourseCard';
import AvatarCard from '@/components/AvatarCard';
import weChat from '@/assets/scripts/wechat';
Vue.use(Lazyload).use(Row).use(Col).use(Swipe).use(SwipeItem).use(Icon).use(ImagePreview)

export default {
    name: 'Venue',
    components: {
        TheTabbar,TheCopyright,TheVenue,CycleCard,AvatarCard,CourseCard
    },
    filters: {
        filterFun: function (value) {
        if(value&& value.length > 8) {
            value= value.substring(0,100)+ '...';
        }
        return value;
        }
    },
    data(){
        return {
            SwiperImgs: [],  // 幻灯片
            clubInfo:{}, // 俱乐部
            courseList:[],  // 团课
            cardList:[],  // 练球卡
            coachList:[],   // 教练
            current:0,
            newMessage3:'' //简介
        }
    },
    created() {
        if(this.$route.params.clubId){
            //路由带参数
            sessionStorage.setItem("CLUBID", this.$route.params.clubId);  //存session
        }else if(!this.$route.params.clubId && sessionStorage.getItem("CLUBID")){
            //路由不带参数但是session有值
        }else{
            sessionStorage.setItem("CLUBID", 1);  //存session 默认1
        }
      
        // 取首页数据
        this.$http.get('club/index?clubId='+sessionStorage.getItem("CLUBID")).then(res => {
            console.log(res);
            if(!res.data.code){
                this.SwiperImgs = res.data.value.clubInfo.detailImgs
                this.clubInfo = res.data.value.clubInfo
                this.courseList = res.data.value.courseList
                this.cardList = res.data.value.cardList
                this.coachList = res.data.value.coachList

                // 简介截取
                this.newMessage3 = this.clubInfo.desc.replace(/<[^>]+>/g,"") //过滤标签
                // this.newMessage3 = this.clubInfo.desc.replace(/<[^>]+>|&[^>]+;/g,"").trim();
                if(this.newMessage3 && this.newMessage3.length > 180) {
                    this.newMessage3= this.newMessage3.substring(0,180)+ '...';
                }

                //配置分享
                var link = window.location.href;
                var title = this.clubInfo.title; // 分享标题
                var desc = this.clubInfo.desc.replace(/<[^>]+>/g,""); // 分享描述
                var imgUrl = this.clubInfo.logo; // 分享图标
                weChat.wxShare(link,title, desc, '', imgUrl);
            }            
        })
    },  
    methods: {
        previewSwiper: function(imgs,index){
            //放大图片路径 拼成数组
            var arr=[];         
            imgs.forEach((item, index) => {
                if(item.mime!='mp4'){
                    arr.push(item.url);
                }
            })
            // console.log(arr)
            ImagePreview(arr, index);
        }
    },
    computed: {
        // newMessage3: function () {
        //     // 截取简介           
        //     let value = this.clubInfo.desc.replace(/<[^>]+>/g,"") //过滤标签
        //     if(value && value.length > 200) {
        //         value= value.substring(0,200)+ '...';
        //     }
        //     return value;
        // }
    }
}
</script>
<style lang="less">
@mg-default:.15rem;
#swiprBox{
    transition: all .5s ease;
    position: relative;
    left: 0
}
.swipe{
    height: 1.8rem;
    img{ width: 100%; height: 100%; object-fit: cover; }
    video{width: 100%;height: 100%;}
}
// 课程模块
.course-mod{
    &.model-box{
        padding: @mg-default 0;
    }
    & .model-box__hd{
        padding: 0 @mg-default;
    }
    & .model-box__bd{
        white-space: nowrap;
        overflow-x: auto; overflow-y: hidden;
        & .coursecard{
            // width: 2.5rem;
            display: inline-block;
            margin-left: @mg-default;
            // &:last-child{
            //     margin-right: @mg-default;
            // }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/Venue.vue